import * as React from 'react';
import injectSheet from 'react-jss';
import { Select, Tooltip } from 'antd';
import Loader from 'src/components/common/Loader';

const styles = (theme: any) => ({});

class SearchTagsInput extends React.PureComponent<any, any> {
  state: any = {
    isSearching: false,
    noResults: false,
    shouldShowOptions: true,
  };

  renderOptions = () => {
    return (this.state.isSearching || !this.state.shouldShowOptions)
      ? null
      : this.props.options.map((elem) => (
          <Select.Option {...elem} key={elem.key}>
            {elem.label}
          </Select.Option>
        ));
  };

  searchTimeOut: any = null;

  handleTextChange = (val) => {
    const { thresholdLength } = this.props;
    if (val.length >= 0) {
      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut);
      }
      this.setState({
        isSearching: true,
        noResults: false,
        shouldShowOptions: false,
      });
      this.searchTimeOut = setTimeout(() => {
        this.searchForData(val);
      }, 300);
    } else if (this.searchTimeOut) {
      clearTimeout(this.searchTimeOut);
    }
  };

  searchForData = async (query) => {
    if (!this.state.isSearching) {
      this.setState({
        isSearching: true,
        noResults: false,
        shouldShowOptions: false,
      });
    }
    await this.props.searchFunction(query);
    
    this.setState({
      isSearching: false,
      shouldShowOptions: true,
    });
  };

  handleFocus = () => {
    const { value, searchOnFocus } = this.props;
    this.setState({ 
      noResults: false,
      shouldShowOptions: false, 
    });
    
    if (!value || !value.label) {
      this.handleTextChange('');
    } else if (value && !(this.props.options && this.props.options.length)) {
      this.handleTextChange(value.label || value);
    } else {
      this.handleTextChange(value.label || value || '');
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.options !== this.props.options && !this.state.isSearching) {
      const hasResults = this.props.options && this.props.options.length > 0;
      this.setState({
        noResults: !hasResults,
        shouldShowOptions: true,
      });
    }
  }

  render() {
    const { isSearching, noResults } = this.state;
    const { options } = this.props;
    
    return (
      <Select
        {...this.props}
        showSearch
        labelInValue
        allowClear={true}
        getPopupContainer={(trigger: any) => trigger.parentNode}
        onFocus={this.handleFocus}
        onSearch={this.handleTextChange}
        notFoundContent={
          noResults ? 'Not Found' : (
            <div style={{ padding: '25px' }}>
              <Loader />
            </div>
          ) 
        }
        loading={isSearching}

        filterOption={
          this.props.filterOption
            ? this.props.filterOption
            : (inputVal, option: any) => {
                if (!inputVal) {
                  return true;
                }
                const optionval = option?.props?.children
                  ? option?.props?.children?.trim()?.toLowerCase()
                  : '';
                return optionval?.includes(inputVal?.trim()?.toLowerCase());
              }
        }
      >
        {this.renderOptions()}
      </Select>
    );
  }
}

export default injectSheet(styles)(SearchTagsInput);
